import {
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import type { ComgateCommentDto } from "Infrastructure/Api/Api";
import type { ReactNode } from "react";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Pages.Content.Merchants.OrbitLOnboarding.Detail;

type Props = {
  comments?: Array<ComgateCommentDto>;
  isLoading: boolean;
};

export const CommentsSection = ({ comments, isLoading }: Props) => {
  const { t } = useResource();

  if (isLoading) {
    return (
      <Layout>
        <CircularProgress size={20} />
      </Layout>
    );
  }

  const hasNoComments = !comments || comments.length === 0;
  if (hasNoComments) {
    return (
      <Layout>
        <Typography variant="body2" color="text.secondary">
          {t(RESOURCES.NoComments)}
        </Typography>
      </Layout>
    );
  }

  return (
    <Layout>
      <List dense disablePadding>
        {comments.map(({ commentDate, commentText, author }, index) => (
          <ListItem
            key={`${commentDate}-${index}`}
            disableGutters
            sx={{
              py: 0.5,
              borderBottom: "1px solid",
              borderColor: "divider",
            }}
          >
            <ListItemText
              primary={commentText}
              secondary={`${author} — ${commentDate}`}
            />
          </ListItem>
        ))}
      </List>
    </Layout>
  );
};

const Layout = ({ children }: { children: ReactNode }) => {
  const { t } = useResource();

  return (
    <Stack gap={1}>
      <Typography variant="subtitle2">
        {t(RESOURCES.CommentsSection)}
      </Typography>
      {children}
    </Stack>
  );
};
